module.exports = __webpack_public_path__ + "img/cross_red.c56c2e3f.svg";